import React from "react";
import VariantOptionsForm from "./VariantOptionsForm";

const VariantOptionsCreate = () => {
  return <VariantOptionsForm />;
};

export default VariantOptionsCreate;